import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "form-section" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }

import UserNavbar from "@/components/UserNavbar.vue";
import UserFooter from "@/components/UserFooter.vue";
import { ref, onMounted } from "vue";
import * as common from "@/assets/common/common";
import { getRequestEndpoint } from "@/config/env";
import { useRoute } from "vue-router";
import { useNotification } from "naive-ui";
interface UserInfo {
  name: string;
  birthday: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ReportDownload',
  setup(__props) {

const route = useRoute();
const projectSKFromRoute = ref<string | null>(null);
const projectTypeFromRoute = ref<string | null>(null);
const projectName = ref<string | null>(null);
const pageLoading = ref(false);
const isDownloading = ref(false);

const notification = useNotification();

const formModel = ref<UserInfo>({
  name: "",
  birthday: "",
});

async function submitDownload() {
  if (!formModel.value.name) {
    notification.error({
      title: "입력 오류",
      description: "이름을 입력해주세요.",
      duration: 3000,
    });
    return;
  }
  if (!formModel.value.birthday || !/^\d{8}$/.test(formModel.value.birthday)) {
    notification.error({
      title: "입력 오류",
      description: "생년월일 8자리(YYYYMMDD)를 정확히 입력해주세요.",
      duration: 3000,
    });
    return;
  }
  isDownloading.value = true;
  await downloadReportFile();
  isDownloading.value = false;
}

async function downloadReportFile() {
  if (!projectSKFromRoute.value) {
    notification.error({
      title: "오류",
      description: "다운로드할 파일 정보가 없습니다.",
      duration: 3000,
    });
    return;
  }

  pageLoading.value = true;

  try {
    const downloadFunctionUrl = getRequestEndpoint("examineeDownload");
    if (!downloadFunctionUrl || typeof downloadFunctionUrl !== "string") {
      throw new Error("다운로드 서비스 URL을 가져올 수 없습니다.");
    }

    const response = await fetch(downloadFunctionUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        SK: projectSKFromRoute.value,
        name: formModel.value.name,
        birthday: formModel.value.birthday,
      }),
    });

    if (!response.ok) {
      let errorBodyText = `HTTP 오류: ${response.status}`;
      try {
        const errorResult = await response.json();
        errorBodyText =
          common.getResultError(errorResult) ||
          errorResult.message ||
          errorResult.error ||
          `서버 오류: ${response.status}`;
      } catch (e) {
        // 응답이 JSON이 아니거나 파싱 실패 시 statusText 사용
        errorBodyText = response.statusText || `서버 오류: ${response.status}`;
      }
      throw new Error(errorBodyText);
    }

    const blob = await response.blob();
    let filename = formModel.value.name;
    if (projectTypeFromRoute.value) {
      const typePrefix = projectTypeFromRoute.value.split("_")[0].toUpperCase();
      filename = `${typePrefix}-${filename}`;
    }

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    notification.success({
      title: "성공",
      description: `${filename} 파일 다운로드가 시작되었습니다.`,
      duration: 3000,
    });
  } catch (error: any) {
    console.error("파일 다운로드 실패:", error);
    notification.error({
      title: "다운로드 실패",
      description: error.message || "파일 다운로드 중 오류가 발생했습니다.",
      duration: 5000,
    });
  } finally {
    pageLoading.value = false;
  }
}

onMounted(async () => {
  projectSKFromRoute.value = route.params.SK as string;
  projectTypeFromRoute.value = route.params.TYPE as string;
  projectSKFromRoute.value = decodeURIComponent(projectSKFromRoute.value);
  projectTypeFromRoute.value = decodeURIComponent(projectTypeFromRoute.value);
  projectName.value = common.getProjectName(projectTypeFromRoute.value);
});

// If you need to use the notification object from a library like Naive UI,
// and it's not globally registered, you'd typically get it from a composable:
//
// import { useMessage, useNotification } from 'naive-ui' // Example for Naive UI
//
// // Inside setup():
// const message = useMessage()
// const notification = useNotification()
//
// // Then use `notification.error({...})` or `message.error(...)`

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UserNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[7] || (_cache[7] = _createElementVNode("div", null, [
        _createElementVNode("h1", null, "검사 결과 다운로드")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { for: "name" }, "검사종류", -1)),
          _createElementVNode("span", null, _toDisplayString(projectName.value), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "name" }, "이름", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "name",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.name) = $event)),
            placeholder: "이름을 입력하세요"
          }, null, 512), [
            [_vModelText, formModel.value.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { for: "birthday" }, "생년월일 (8자리) (예: 19990101)", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "birthday",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.birthday) = $event)),
            placeholder: "YYYYMMDD",
            maxlength: "8"
          }, null, 512), [
            [_vModelText, formModel.value.birthday]
          ])
        ]),
        _createVNode(_component_n_button, {
          loading: isDownloading.value,
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (submitDownload()))
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode(" 다운로드 ")
          ])),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createVNode(UserFooter)
  ], 64))
}
}

})